import { gql } from '@apollo/client';

export const getOpportunityBubbleChart = gql`
    query getOpportunityBubbleChart(
        $timePeriod: JSONString!
        $filters: JSONString!
        $groupBy: SamyaString!
        $dimension: SamyaString!
    ) {
        getOpportunityBubbleChart(
            timePeriod: $timePeriod
            filters: $filters
            groupBy: $groupBy
            dimension: $dimension
        ) {
            groupBy
            kpisData {
                kpiName
                kpiValue
            }
        }
    }
`;

export const getOpportunityTrendsChart = gql`
    query getCompetitorsElasticityWeekLvlData(
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $dimension: SamyaString!
    ) {
        getCompetitorsElasticityWeekLvlData(
            timePeriod: $timePeriod
            attributeType: $attributeType
            filters: $filters
            dimension: $dimension
        ) {
            data {
                attributeName
                startTimestamp
                periodLabel
                bpeCurrent
                bpePrevious
            }
            count
        }
    }
`;

export const getChart2Chart = gql`
    query getAttributeLvlElasticityBreakdown(
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $dimension: SamyaString!
        $limit: Int!
        $offset: Int!
    ) {
        getCompetitorsElasticityBreakdown(
            timePeriod: $timePeriod
            attributeType: $attributeType
            filters: $filters
            dimension: $dimension
            limit: $limit
            offset: $offset
        ) {
            count
            attributeData {
                attributeName
                competitorAttributeName
                competitorType
                bpe
            }
        }
    }
`;
